import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { MyCollectionsScreen } from "@/features/assets/components/MyCollectionsScreen";
import { normalizeAssetQuery } from "@/features/assets/queries";
import { useSearchField } from "@/features/assets/search-field";

export const Route = createFileRoute("/_authenticated/assets/collections/mine")({
  validateSearch: (search: Record<string, unknown>): { q?: string } => {
    const q = normalizeAssetQuery(search.q)?.slice(0, 80);
    return q ? { q } : {};
  },
  staticData: { access: "account" },
  head: () => ({ meta: [{ title: "My collections · Pax.co" }] }),
  component: MyCollectionsPage,
});

function MyCollectionsPage() {
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();
  const commitSearch = useCallback(
    (next: string | undefined) =>
      void navigate({ search: { q: next }, replace: true, resetScroll: false }),
    [navigate],
  );
  const [searchValue, setSearchValue] = useSearchField(q, commitSearch);

  return <MyCollectionsScreen q={q} searchValue={searchValue} onSearchChange={setSearchValue} />;
}
